import React, { Component } from "react";

import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CSpinner
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import CommunityUsersSelector from "../CommunityUsersSelector";

import "./style.css";

class UsersCommunityModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // list: [],
      // loading: true,
      // applications: [],
      creating: false,
      selectedUsers: []
    };
  }

  error(msg) {
    toastr.error("Erro", msg);
  }

  insert() {
    this.setState({ creating: true });

    const date = new Date();
    const dateStr = `${date.getFullYear()}-${`00${date.getMonth() + 1}`.slice(
      -2
    )}-${`00${date.getDate()}`.slice(-2)} ${`00${date.getHours()}`.slice(
      -2
    )}:${`00${date.getMinutes()}`.slice(-2)}:${`00${date.getSeconds()}`.slice(
      -2
    )}`;

    const obj = this.state.selectedUsers.map(user => ({
      room_id: parseInt(this.props.room),
      user_id: user.id,
      administrator: !!user.administrator,
      start: dateStr,
      authorized: true,
      request: false,
      disciplines: user.disciplines ? user.disciplines : null
    }));

    axios
      .post(
        `${URL.api}community/room_user/insertMany`,
        { data: obj },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.props.onClose(true);
        },
        () => {
          this.error("Não foi possível inserir os usuários");
          this.setState({ creating: false });
        }
      );
  }

  render() {
    return (
      <CModal
        size="lg"
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
        centered
      >
        <CModalHeader closeButton>
          <CModalTitle>Adicionar membros</CModalTitle>
        </CModalHeader>
        <CModalBody
          className="p-0 d-flex flex-column w-100"
          style={{ overflow: "hidden" }}
        >
          <CommunityUsersSelector
            onChange={e => this.setState({ selectedUsers: e })}
            id={this.props.room}
            isRoom
            onlyAdd
          />
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="d-flex justify-content-center align-items-center"
            onClick={() => this.insert()}
            disabled={this.state.creating}
          >
            <>
              <span style={this.state.creating ? { opacity: 0 } : null}>
                <i className="fa fa-cloud-upload mr-2"></i>Salvar
              </span>
              {this.state.creating && (
                <CSpinner
                  size="sm"
                  color="white"
                  style={{ position: "absolute" }}
                />
              )}
            </>
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsersCommunityModal);
